import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[cmxRowTemplate]',
})
export class CmxRowTemplateDirective {
    constructor( public template: TemplateRef<any> ) { }
}
